import { compose, branch, renderNothing, lifecycle, mapProps } from 'recompose';
import { ApiClient } from 'services';
import { toPairs, indexOf, map, sortBy, omit } from 'lodash';
import shortid from 'shortid';

const resolvedKey = shortid();

const withResolver = (
  resolves,
  {
    onResolved,
    onResolveError,
    renderBeforeResolve = false,
    getClient = () => ApiClient(),
    ordering = null,
  }
) =>
  compose(
    lifecycle({
      componentDidMount() {
        const { props } = this;
        const client = getClient(props);
        let pairs = toPairs(resolves);
        const resolvedSoFar = {};

        if (ordering) {
          pairs = map(pairs, i => {
            const index = indexOf(ordering, i[0]);
            return [...i, index === -1 ? null : index];
          });
          pairs = sortBy(pairs, i => i[2]);
        }

        Promise.map(pairs, ([key, resolve]) =>
          Promise.resolve(resolve(props)(client, resolvedSoFar)).then(resp => {
            resolvedSoFar[key] = resp.data;
          })
        )
          .tap(() => {
            onResolved(props)(resolvedSoFar);
            this.setState({ [resolvedKey]: true });
          })
          .catch(err => {
            if (onResolveError) {
              const setResolved = () => {
                this.setState({ [resolvedKey]: true });
              };
              onResolveError({ setResolved, ...props })(err, resolvedSoFar);
            } else {
              throw err;
            }
          });
      },
    }),
    branch(props => renderBeforeResolve || !props[resolvedKey], renderNothing),
    mapProps(props => omit(props, resolvedKey))
  );

export default withResolver;



// WEBPACK FOOTER //
// ./src/components/common/withResolver.js